import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    margin: 0,
    boxSizing: "border-box"
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export default function ProductGrid(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container>
        {props.children}
      </Grid>
    </div>
  );
}
